import { Button } from 'tusk-ui'

export default Button
